import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFeather2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="feather-2, writing"><path d="M3.75 16.1029V21.25C3.75 17.9746 6.51382 15.75 9.52918 15.75C13.3388 15.75 16.1409 12 14.0757 8.89706C17.4661 8.89706 18.206 6.41115 19.6 3.75H16.1409C9.29758 3.75 3.75 9.2806 3.75 16.1029Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFeather2;
